import {API_BASE_URL} from "../common/ApiUrl";
import axios from "axios";

const authHeaders = (token) => ({
    headers: {Authorization: `Bearer ${token}`},
});

// Utility function for retry logic
const withRetry = async (apiCall, maxRetries = 3) => {
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await apiCall();
        } catch (error) {
            const isLastAttempt = attempt === maxRetries;
            const shouldRetry = !isLastAttempt && (
                error.response?.status === 401 || 
                error.response?.status === 403 || 
                !error.response
            );
            
            if (shouldRetry) {
                const delay = Math.pow(2, attempt) * 1000; // Exponential backoff
                await new Promise(resolve => setTimeout(resolve, delay));
                continue;
            }
            
            throw error;
        }
    }
}

class LaneService {
    async getTopLanes(token) {
        return axios.get(`${API_BASE_URL}top_routes`, authHeaders(token));
    }

    async getLaneStatistics(pick_city, pick_state, drop_city, drop_state, equipment, pick_city_radius, drop_city_radius, days, token, search_source) {
        let url = `${API_BASE_URL}lane-statistics?pick_city=${pick_city}&drop_city=${drop_city}&pick_state=${pick_state}&drop_state=${drop_state}&equipment=${equipment}&pick_city_radius=${pick_city_radius}&drop_city_radius=${drop_city_radius}&days=${days}`;
        if (search_source) {
            url += `&search_source=${encodeURIComponent(search_source)}`;
        }
        return axios.get(url, authHeaders(token));
    }

    async syncDashBoard(data, token) {
        return axios.post(`${API_BASE_URL}dashboard`, data, authHeaders(token));
    }

    async planRoute(data, token) {
        return axios.post(`${API_BASE_URL}routing/plan`, data, authHeaders(token));
    }

    async deleteDashBoardItem(sub, item, token) {
        return axios.put(`${API_BASE_URL}dashboard-delete`, {sub: sub.sub, item}, authHeaders(token));
    }

    async shuffleDashBoardItem(sub, item, op, token) {
        return axios.put(`${API_BASE_URL}dashboard-shuffle`, {sub: sub.sub, item, op}, authHeaders(token));
    }

    async getCityOptions(query, token) {
        const res = await axios.get(`${API_BASE_URL}city_search?q=${query}`, authHeaders(token));
        return res.data;
    }

    async getCityOptionsFromMileMaker(query, token) {
        const res = await axios.get(`${API_BASE_URL}search/free-text?q=${query}`, authHeaders(token));
        return res.data;
    }

    async getUserRateSearchOptions(token) {
        const res = await axios.get(`${API_BASE_URL}rate_search`, authHeaders(token));
        return res.data;
    }

    async deleteRateSearchHistory(id, token) {
        return axios.delete(`${API_BASE_URL}rate_search/${id}`, authHeaders(token));
    }

    async getCityOptionsTwo(query, token) {
        const res = await axios.get(`${API_BASE_URL}city_top_routes`, authHeaders(token));
        return res.data;
    }

    async getCityOptionsThree(query, token, city, stateName, radiusValue, equipmentValue, drop_city, drop_state, drop_city_radius, days) {
        const url = `${API_BASE_URL}city_top_paying_collection?pick_city=${city}&pick_state=${stateName}&pick_city_radius=${radiusValue}&equipment_value=${equipmentValue}&drop_city=${drop_city}&drop_state=${drop_state}&drop_city_radius=${drop_city_radius}`;
        const res = await axios.get(url, authHeaders(token));
        return res.data;
    }

    async loadDashBoard(token) {
        const res = await axios.get(`${API_BASE_URL}dashboard-items`, authHeaders(token));
        return res.data;
    }

    async loadDashBoardFavorites(token) {
        const res = await axios.get(`${API_BASE_URL}dashboard-fav-items`, authHeaders(token));
        return res.data;
    }

    async getTickerOne(token) {
        return withRetry(async () => {
            const res = await axios.get(`${API_BASE_URL}ticker/one`, authHeaders(token));
            return res.data;
        });
    }

    async getTickerTwo(token) {
        return withRetry(async () => {
            const res = await axios.get(`${API_BASE_URL}ticker/two`, authHeaders(token));
            return res.data;
        });
    }

    async sendRouteEmail(emailData, token) {
        return axios.post(`${API_BASE_URL}routing/send-email`, emailData, authHeaders(token));
    }

    async getLaneStatisticsByLatLng(pickCityLat, pickCityLng, dropCityLat, dropCityLng, equipment, pickCityRadius, dropCityRadius, token) {
        const url = `${API_BASE_URL}lane-statistics-lat-lng?pickCityLat=${pickCityLat}&pickCityLng=${pickCityLng}&dropCityLat=${dropCityLat}&dropCityLng=${dropCityLng}&equipment=${equipment}&pick_city_radius=${pickCityRadius}&drop_city_radius=${dropCityRadius}`;
        return axios.get(url, authHeaders(token));
    }
}

export default new LaneService();